import type { Key } from '../i18n';

/**
 * The seating arrangements the venue form offers.
 *
 * The column is free text on the server, so what is stored here is the English
 * wording whatever language the manager is working in — a venue's data should
 * not change shape because of who edited it last. Only the label is translated,
 * on the form and on the public page alike, through [seatingLayoutKey].
 */
export const SEATING_LAYOUTS = [
  'Flexible / whole-hall',
  'Theatre style',
  'Banquet rounds',
  'Classroom',
  'U-shape',
  'Fixed tiered seating',
  'Multiple halls',
] as const;

const KEYS: Record<string, Key> = {
  'Flexible / whole-hall': 'layoutFlexible',
  'Theatre style': 'layoutTheatre',
  'Banquet rounds': 'layoutBanquet',
  Classroom: 'layoutClassroom',
  'U-shape': 'layoutUShape',
  'Fixed tiered seating': 'layoutTiered',
  'Multiple halls': 'layoutMultiple',
};

/**
 * The translation key for a stored layout, or null for wording this list does
 * not know — a venue set up before the dropdown existed carries free text, and
 * that is shown as typed rather than dropped.
 */
export const seatingLayoutKey = (value: string): Key | null => KEYS[value] ?? null;
